export default class Player {
    constructor(name) {
        this.name = name;
        this.thrown = [0];
        this.active = false;
    }

    throw(score){
        this.thrown.push(score);
    }

    getScoreForTurn(baseScore, turn){
        let score = baseScore;

        for(let i = 0; i <= turn; i++){
            score -= this.thrown[i];
        }

        return score;
    }

    getCurrentScore(baseScore){
        let score = baseScore;

        for(let i = 0; i < this.thrown.length; i++){
            score -= parseInt(this.thrown[i]);
        }

        return score;
    }

    undoLastTurn(){
        if(this.thrown.length > 1){
            this.thrown.splice(-1, 1);
        }

    }
}